import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import App from "./app/App";
import Login from "./app/user-pages/Login";
import "./i18n";
import * as serviceWorker from "./serviceWorker";
import { Context, ContextProvider } from "./auth/Context";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./index.css";

ReactDOM.render(
  <ContextProvider>
    <BrowserRouter basename="">
      <Switch>
        <Route path="/login" component={Login} />
        <Route path="/" component={App} />
      </Switch>
      <ToastContainer position="top-center" autoClose={5000} />
    </BrowserRouter>
  </ContextProvider>,
  document.getElementById("root")
);

serviceWorker.unregister();
